/**
 * Copyright (C) IRT GmbH 2020
 */

function createElement(pElement, nodeName, className, textContent) {
    var elem = document.createElement(nodeName);
    if (className)
        elem.setAttribute("class", className);
    if (textContent)
        elem.appendChild(document.createTextNode(textContent));

    return pElement.appendChild(elem);
}

/**
 * @param {Element} parent
 */
function DebugInfo(parent, opt) {

    var pageElement = createElement(parent, "div", "debug-info");
    createElement(pageElement, "div", "version", "APP: " + opt.appVersion);
    createElement(pageElement, "div", "version", "LIB: " + opt.libVersion);

    function setVisible (visible) {
        pageElement.classList[visible ? "remove" : "add"]("hidden");
    }

    return {
        setVisible : setVisible
    };
}

module.exports = DebugInfo;
